import React from "react";
import { Image, Container } from "semantic-ui-react";
import { Link } from "react-router-dom";
import { Icon } from "../../../assets";
import { image } from "../../../assets";
import { ENV } from "../../../utils";
import "./TopBar.scss";

export function TopBar({ showExitIcon }) {

  return (
    <div className="top-bar">
      <Container>

        <div className="top-bar__left">

          <Link to="/" className="logo">
            <Icon.LogoWhite />
          </Link>

          <div className="separator">
            <Image src={ image.separator }/>
          </div>

          <div className="gateway">
            <Image src={ image.gateway }/>
          </div>

          <div className="gateway_text">
            { ENV.TEXT.PSE}
          </div>

        </div>

        {showExitIcon && ( <div className="top-bar__right">

          <a href={ENV.BASE_BOX} className="exit_text">
              Salir
            </a>

          <a href={ENV.BASE_BOX} className="exit">
            <Image src={image.logOut} />
          </a>

        </div> )}

      </Container>
    </div>
  );

}
